import { render, staticRenderFns } from "./lawyerServiceFile.vue?vue&type=template&id=18ef7262&scoped=true"
import script from "./lawyerServiceFile.vue?vue&type=script&lang=js"
export * from "./lawyerServiceFile.vue?vue&type=script&lang=js"
import style0 from "./lawyerServiceFile.vue?vue&type=style&index=0&id=18ef7262&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef7262",
  null
  
)

export default component.exports